import axios from 'axios';

const api = axios.create({
    baseURL: '/admin/activity/'
});

export const Activity = {
    changeStatus: (status) => api.post('change-status', { status })
};